// @ts-ignore
import Vue from 'vue';
// @ts-ignore
import {  Component, Prop} from "vue-property-decorator";

//Components
import WithRender from 'Components/Favorites/Favorites.html';

//Child Components
import ProductCard from "Components/Shared/ProductCard/ProductCard";
import WorkbenchCard from "Components/Shared/WorkbenchCard/WorkbenchCard";


//Interfaces
import { IfcFavoritesRequest } from "Interfaces/IfcFavoritesRequest";
import { IfcFavoriteProjectsRequest } from "Interfaces/IfcFavoritesRequest";
import { IfcProduct } from "Interfaces/IfcProduct";
import { IfcWorkbenchProjects } from 'Interfaces/IfcWorkbenchProjects';
import { IfcWorkbenchPageData } from 'Interfaces/ifcWorkbenchPageData';

//API Service
import FavoritesService from "Services/favoritesService";

declare var __sharethis__:any;

@WithRender
@Component({
	components: {
		ProductCard,
		WorkbenchCard
	}
})

export default class Favorites extends Vue {
	pageData = JSON.parse(document.querySelector('.js-page-data').getAttribute('data-page-data')) as IfcWorkbenchPageData;
	translations = JSON.parse(document.querySelector('.js-page-data').getAttribute('data-translations'));
	favoriteProducts: IfcProduct[] = [];
	workbenchProjects: IfcWorkbenchProjects[] = [];		
	projectsBaseUrl: string;
	isLoading: boolean = false;
	isSharedMode: boolean = false;
	projectsLoaded:boolean = false;
	stockNumbersString: string;
	projectsString: string;
	favoritesRequest: IfcFavoritesRequest = {
		stockNumbers: []
	};
	favoriteProjectsRequest: IfcFavoriteProjectsRequest = {
		projectSlugs: []
	};

	$refs!: {	
		resultsWrap: HTMLElement
	};

	created() {
		let vm = this;
		const queryParams = new URLSearchParams(window.location.search);
		if(queryParams.has('stockNumbers')) {
			vm.stockNumbersString = queryParams.has('stockNumbers') ?  queryParams.get('stockNumbers') : null;
			vm.favoritesRequest.stockNumbers = vm.stockNumbersString.split(',');
			vm.isSharedMode = true;
		}
		if(queryParams.has('projects'))
		{
			vm.projectsString = queryParams.has('projects') ?  queryParams.get('projects') : null;
			vm.favoriteProjectsRequest.projectSlugs = vm.projectsString.split(',');
			vm.isSharedMode = true;			
		}
		else 
		{
			vm.getAllProjectKeys();
			vm.getAllProductKeys();			
		}
		if(this.favoriteProjectsRequest.projectSlugs.length > 0)
		{
			vm.getProjects(vm.favoriteProjectsRequest);		
		}			
		if(this.favoritesRequest.stockNumbers.length > 0)
		{
		    vm.getProducts(vm.favoritesRequest);
		}			
	}   
	mounted()
	{
		let vm = this;
		document.onreadystatechange = () => {
			if (document.readyState == "complete") {
				vm.updateShareUrl();				
			}
		  }		 
	} 
	favoriteProductRemoved(event:any, stockNumber:string)
	{
		event.preventDefault();
		event.stopPropagation();  
		    let productIds = this.getFavoriteProducts();
            if (stockNumber != null) {               
                    productIds.splice(productIds.indexOf(stockNumber), 1);                    
               
                localStorage.setItem('favorite-products', JSON.stringify(productIds));
            }  
			var index = this.favoriteProducts.findIndex( (i) => i.stockNumber === stockNumber);
			if (index !== -1) {
				this.favoriteProducts.splice(index, 1 );
			}                    
            // This event triggers the Favorites counter in the nav to update             
            window.dispatchEvent(new Event('favorites'));   
			     
		
	}
	getFavoriteProducts(): string[] {
		let productIds: string[] = [];
		if (localStorage.getItem('favorite-products')) {
			productIds = JSON.parse(localStorage.getItem('favorite-products'));
		}
		return productIds;
	}	
	favoriteProjectRemoved(event:any, urlName:string)
	{
		event.preventDefault();
		event.stopPropagation(); 
		let projectIds = this.getFavoriteProjects();
            if (urlName != null) {               
				projectIds.splice(projectIds.indexOf(urlName), 1);                    
               
                localStorage.setItem('favorite-projects', JSON.stringify(projectIds));
            }  
		var index = this.workbenchProjects.findIndex( (i) => i.UrlName === urlName);
			if (index !== -1) {
				this.workbenchProjects.splice(index, 1 );
			}
			 // This event triggers the Favorites counter in the nav to update             
			 window.dispatchEvent(new Event('favorites'));   
	}
	getFavoriteProjects(): string[] {
		let projectIds: string[] = [];
		if (localStorage.getItem('favorite-projects')) {
			projectIds = JSON.parse(localStorage.getItem('favorite-projects'));
		}
		return projectIds;
	}

	updateShareUrl() {
		let vm = this;
		const buttons = document.querySelector('.sharethis-inline-share-buttons');
		var newUrl = window.location.href + `?stockNumbers=` + vm.stockNumbersString  + `&projects=` + vm.projectsString;
		buttons.setAttribute('data-url', newUrl ) 
		__sharethis__.initialize();
    }

	baseUrl() {
		return window.location.pathname;
	}

	getAllProductKeys(): void {
		let keyName = 'favorite-products';
		if (localStorage.getItem(keyName)) {
			let stockNumbers = JSON.parse(localStorage.getItem(keyName));
			this.stockNumbersString = stockNumbers.toString();
			stockNumbers = stockNumbers.sort();

			// Eliminate any null product IDs
			for (let i = stockNumbers.length - 1; i >= 0; i--) {
				if (stockNumbers[i] == null) {
					stockNumbers.splice(i, 1);
				}
			}
			this.favoritesRequest.stockNumbers = stockNumbers;
		}
	}

	getAllProjectKeys(): void {
		let keyName = 'favorite-projects';
		if (localStorage.getItem(keyName)) {
			let projectSlugs = JSON.parse(localStorage.getItem(keyName));
			this.projectsString = projectSlugs.toString();
			projectSlugs = projectSlugs.sort();

			// Eliminate any null project Slugs
			for (let i = projectSlugs.length - 1; i >= 0; i--) {
				if (projectSlugs[i] == null) {
					projectSlugs.splice(i, 1);
				}
			}
			this.favoriteProjectsRequest.projectSlugs = projectSlugs;
		}
		
	}
	
	 getProjects(request: IfcFavoriteProjectsRequest) {
		let vm = this;
			
		for (let nextSlug of request.projectSlugs) {
			for(let i=0; i< vm.pageData.Projects.length; i++)
			{				
				if(vm.pageData.Projects[i]['UrlName'] === nextSlug)
				{
					let ifcProject = <IfcWorkbenchProjects>{};
					Object.assign(ifcProject, vm.pageData.Projects[i]);
					vm.workbenchProjects.push(ifcProject);									
				}
			}			
		}
		FavoritesService.init(null, this.workbenchProjects);		
	}	
		
	/**
	 * Calls favorites service
	 * @param request request object of type IfcFavoritesRequest
	 */
	 getProducts(request: IfcFavoritesRequest) {
		let vm = this;
		vm.isLoading = true;
		FavoritesService.fetchApiProductData(request).then(response => {
			vm.favoriteProducts = response.data.products;
			vm.favoritesRequest.stockNumbers = response.request;
			vm.isLoading = false;					
		}).catch(function() {			
			vm.isLoading = false;		
		});		
	}
	
	doPrint(e) {
		e.preventDefault();
		window.print();
	}
}

